<template>
	<div class="bspMask">
		<slot></slot>
	</div>
	</template>
	<script>
		export default {
			name: "bspMask",
			
			
			}
	</script>
	<style scoped="scoped">
		.bspMask{
			position: fixed;
			left: 0;
			top: 0;
			width: 100vw;
			height: 100vh;
			z-index: 200;
			background: rgba(0,0,0,.2);
			display: flex;
			justify-content: center;
			align-items: center;
		}
	</style>
	